import { AbstractFormulaParser } from './AbstractFormulaParaser';

export class FormulaParser extends AbstractFormulaParser {}
